import { Box, IconButton } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { APP_COLOR, FONT_FAMILY } from "../../theme";

export interface ZeroUploadsToastProps {
  open: boolean;
  onClose?: () => void;
  title?: string;
  body?: string;
}

const SURFACE = "#151718";
const BORDER = "#26292B";
const MUTED = "#889096";
const FAINT = "#5b626a";

const ZeroUploadsToast: React.FC<ZeroUploadsToastProps> = ({
  open,
  onClose,
  title = "You’re all set, welcome aboard",
  body = "Drop your first track to get started.",
}) => {
  if (!open) return null;
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: "fixed",
        right: 26,
        bottom: 26,
        zIndex: 1400,
        display: "flex",
        alignItems: "center",
        gap: "13px",
        background: SURFACE,
        border: `1px solid ${BORDER}`,
        borderLeft: `3px solid ${APP_COLOR}`,
        borderRadius: "12px",
        padding: "14px 18px 14px 15px",
        boxShadow: "0 20px 50px -20px rgba(0,0,0,0.7)",
        maxWidth: 360,
        fontFamily: FONT_FAMILY,
      }}
    >
      <Box
        sx={{
          width: 34,
          height: 34,
          flex: "0 0 34px",
          borderRadius: "9px",
          background: "rgba(39,182,203,0.14)",
          color: APP_COLOR,
          display: "grid",
          placeItems: "center",
        }}
      >
        <CheckIcon sx={{ fontSize: 18 }} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <Box component="b" sx={{ color: "#FFFFFF", fontSize: 14, fontWeight: 600, display: "block" }}>
          {title}
        </Box>
        <Box component="span" sx={{ color: MUTED, fontSize: 12.5 }}>
          {body}
        </Box>
      </Box>
      {onClose && (
        <IconButton onClick={onClose} aria-label="Dismiss" sx={{ color: FAINT, padding: 0, marginLeft: "6px" }}>
          <CloseIcon sx={{ fontSize: 15 }} />
        </IconButton>
      )}
    </Box>
  );
};

export default ZeroUploadsToast;
